import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import '../../css/centeredContainer.css';
import '../../css/Home.css';

import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

export default function DemoVideo({ isNavOpen }) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  // Normalize language
  const lang = i18n.language?.split('-')[0] === 'es' ? 'es' : 'en';

    // Track screen width
  const [isVertical, setIsVertical] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsVertical(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const demoVideoSrc = isVertical
    ? lang === 'es'
      ? '/promoVideos/dnzify_espanol_vertical.mp4'
      : '/promoVideos/dnzify_english_vertical.mp4'
    : lang === 'es'
      ? '/promoVideos/dnzify_espanol_horizontal.mp4'
      : '/promoVideos/dnzify_english_horizontal.mp4';

  return (
    <div className={isNavOpen ? 'body-squeezed' : 'body'}>

      {/* Back button */}
      <div style={{ padding: '1.5rem', display: 'flex', justifyContent: 'center'}}>
        <button
          className="button-white"
          onClick={() => navigate(-1)}
        >
          <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: 8 }} />
          {t('common.back', 'Back')}
        </button>
      </div>

      {/* Video container */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '1rem'
        }}
      >
        <video
          controls
          preload="metadata"
            key={demoVideoSrc}   //forces reload on orientation/lang change
          style={{
            width: '100%',
            // maxWidth: isVertical ? '620px' : '1200px',
            maxHeight: '75vh',
            borderRadius: '12px'
          }}
        >
          <source src={demoVideoSrc} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
}
